import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import JobsTable from "../components/job/JobsTable";
import PageContainer from "../components/shared/PageContainer";
import { useAutoUpdate } from "../contexts/AutoUpdateContext";
import * as Objects from "../services/api/";

const Backfill: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [jobs, setJobs] = useState<Objects.Job[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [availableSets, setAvailableSets] = useState<Objects.TemplateSetAggregate[]>([]);
  const autoUpdate = useAutoUpdate();

  const fetchData = useCallback(() => {
    // If user or app doesn't specify page/limit set it to default values.
    const defaultParams = { page: 1, limit: 25, backfill: true };
    const parsedParams = Object.fromEntries(searchParams);
    const queryParams = { ...defaultParams, ...parsedParams };
    Objects.Jobs.list(queryParams).then((result) => {
      setJobs(result.items);
      setTotalRows(result.count);
    });
  }, [searchParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let intervalId = autoUpdate.active ? setInterval(fetchData, 5000) : null;
    return () => (intervalId ? clearInterval(intervalId) : undefined);
  }, [fetchData, autoUpdate.active]);

  useEffect(() => {
    Objects.TemplateSets.list().then(setAvailableSets);
  }, []);

  return (
    <PageContainer>
      <JobsTable jobs={jobs} totalRows={totalRows} availableSets={availableSets} />
    </PageContainer>
  );
};

export default Backfill;
